import React from 'react';
import { strings } from 'src/localization';
import * as css from './ReyPAY.module.scss';
import { Link } from '@framework-controls/core';
import classNames from 'classnames';

export interface IProps {
    status: string;
    link: string;
    name: string;
    theme: string;
    clickHandler: (e: any) => void;
}

const ReyPAY = (props: IProps) => {
    const name = props.name;
    let title = strings.InvoiceReady;
    let description = strings.BillReady;
    let label = strings.PayNow;
    if (props.status === 'paid') {
        title = strings.InvoicePaid;
        description = strings.PaymentReceived;
        label = strings.ViewInvoice;
    }
    const classes = classNames(
        css.currentRepairCard,
        {
            [css.blueBorder]: props.status !== 'paid',
            [css.greenBorder]: props.status === 'paid',
        },
    );

    const titleStyles = classNames(
        css.title,
        {
            [css.titleBMW]: props.theme === 'bmw',
            [css.titleFord]: props.theme === 'ford',


        },
    );

    const labelStyles = classNames(
        css.label,
        {
            [css.labelBMW]: props.theme === 'bmw',

        },
    );

    return (
        <div className={classes}>
            <span className={titleStyles}><span className={css.currency}>{strings.Dollar}</span> {title}</span>
            <p className={css.description}>{name + description}</p>
            <div className={css.link}>
                <Link
                    id='ReyPAYLink'
                    url={props.link}
                >
                    <span className={labelStyles} onClick={props.clickHandler}>{label}</span>
                </Link>
            </div>
        </div>
    );
};


export default ReyPAY;
